module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_model_train_3e12d2492815c2ee975fd573416e6a1a.png";